var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99992 15.8333H14.9999V7.63081L9.99992 3.08581L4.99992 7.63081V15.8333ZM15.8333 17.5H4.16658C3.94557 17.5 3.73361 17.4122 3.57733 17.2559C3.42105 17.0996 3.33325 16.8877 3.33325 16.6666V9.16664H0.833252L9.43908 1.34331C9.59251 1.20371 9.79249 1.12634 9.99992 1.12634C10.2073 1.12634 10.4073 1.20371 10.5608 1.34331L19.1666 9.16664H16.6666V16.6666C16.6666 16.8877 16.5788 17.0996 16.4225 17.2559C16.2662 17.4122 16.0543 17.5 15.8333 17.5ZM6.66658 8.33331C8.21368 8.33331 9.69741 8.94789 10.7914 10.0419C11.8853 11.1358 12.4999 12.6195 12.4999 14.1666H10.8333C10.8333 13.0616 10.3943 12.0018 9.61286 11.2204C8.83146 10.439 7.77165 9.99997 6.66658 9.99997V8.33331ZM6.66658 11.6666C7.32963 11.6666 7.96551 11.93 8.43435 12.3989C8.90319 12.8677 9.16658 13.5036 9.16658 14.1666H6.66658V11.6666Z",
    fill: "#60658D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.952aa239bb4fea2aaf1356c9fd8a530f.svg";
export { ForwardRef as ReactComponent };